import { render } from "./ChangePhoneForm.vue?vue&type=template&id=28652aac&lang=pug"
import script from "./ChangePhoneForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePhoneForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__